import * as Yup from "yup";

export const YUPValidations = Yup.object().shape({
  centrePackageName: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  centrePackageCode: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  mrp: Yup.number()
    .typeError("The field should have digits only")
    .moreThan(0, "MRP should be greater than zero")
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .required("Field is required"),
  walkInPrice: Yup.number()
    .max(Yup.ref("mrp"))
    .typeError("The field should have digits only")
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .moreThan(0, "WalkInPrice should be greater than zero")
    .required("Field is required"),
  gender: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  fastingRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  visitType: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
});

export const initialFilterState = {
  page: 1,
  rows: 10,
  centrePackageCode: null,
  centrePackageName: null,
  sortDirection: "DESC",
  RequestStatus: null,
};

export const initialHeaderTest = [
  "HA Package Name",
  "Walk In Price",
  "MRP (Rs.)",
  "Visit Type",
];

export const TestExcelHeaderColmns = {
  "HA Package Name": "haPackageName",
  "Walk In Price": "walkInPrice",
  "MRP (Rs.)": "mrp",
  "Visit Type": "visitType",
  Status: "requestStatus",
  "Centre Package Code": "centrePackageCode",
  "Centre Package Name": "centrePackageName",
  Gender: "gender",
  "Fasting Required": "fastingRequired",
  // "Client Name": "clientName",
};

export const TestExcelHeader = [
  { label: "HA Package Name", key: "haPackageName" },
  { label: "Walk In Price", key: "walkInPrice" },
  { label: "MRP (Rs.)", key: "mrp" },
  { label: "Visit Type", key: "visitType" },
  { label: "Centre Package Code", key: "centrePackageCode" },
  { label: "Centre Package Name", key: "centrePackageName" },
  { label: "Gender", key: "gender" },
  { label: "Fasting Required", key: "fastingRequired" },
  { label: "Status", key: "requestStatus" },
];
export const CSVData = (getTestPackagesExcelDetail) =>
  getTestPackagesExcelDetail?.map((ele) => {
    return {
      centrePackageName: ele?.centrePackageName,
      centrePackageCode: ele?.centrePackageCode,
      haPackageName: ele?.haPackageName,
      walkInPrice: ele?.walkInPrice,
      mrp: ele?.mrp,
      gender:
        ele?.gender === "M" ? "Male" : ele?.gender === "F" ? "Female" : "Both",
      fastingRequired: ele?.fastingRequired === true ? "Yes" : "No",
      visitType:
        ele?.visitType === "HV"
          ? "Home Visit"
          : ele?.visitType === "DC"
          ? "Centre Visit"
          : ele?.visitType === "MIX"
          ? "Mix Visit"
          : "-",
      // clientName: ele?.clientName,
      requestStatus: ele?.requestStatus,
    };
  });
